import { IOwnerDetailsServiceItem } from 'ui-toolkit/cdItems/service/ServiceInterfaces';
import { IOrderDetailsData } from 'ui-toolkit/orders/interfaces/IOrderDetailsData';
import { isBuyerBorrower } from '../../ui-toolkit/orders/interfaces/IParty';

export const getOwnerDetails = (orderDetails: IOrderDetailsData): IOwnerDetailsServiceItem => ({
  transactionType: orderDetails.transaction.transaction_category,
  ownerType: 'order',
  fileNumber: orderDetails.transaction.file_number || '',
  loanAmount: orderDetails.transaction.loan_amount || 0,
  loanNumber: orderDetails.transaction.loan_number || '',
  purchasePrice: orderDetails.transaction.purchase_price || orderDetails.transaction.estimated_property_value,
  addressInfo: {
    street_address: orderDetails.property.street_address || '',
    state: orderDetails.property.state || '',
    unit: orderDetails.property.unit || '',
    city: orderDetails.property.city || '',
    zip_code: orderDetails.property.zip_code || '',
  },
  borrowers: orderDetails.parties.filter(isBuyerBorrower),
  refiDiscount: orderDetails.orderInformation.refiDiscount,
});
